import { getStaticImageUrl } from 'client/utils/image-helpers';

const APPRAISAL_PROMOTION_HEADER_BACKGROUND_IMAGE = {
  DESKTOP: getStaticImageUrl('appraisal/header-background-v3-clouds.svg'),
  MOBILE: getStaticImageUrl('appraisal/header-background-mobile-v3-clouds-v2.svg'),
};

const APPRAISAL_PROMOTION_HEADER_TEXT = {
  HEADER: "What's it Worth?",
  SUBHEADER: 'See an appraisal and a no-obligation offer.',
};

export const promoImageMap = {
  default: APPRAISAL_PROMOTION_HEADER_BACKGROUND_IMAGE,
};

export const headerTextMap = {
  default: APPRAISAL_PROMOTION_HEADER_TEXT,
};

export const promoHeadingTextClassMap = {
  default: 'text-shadow-contrast',
};
